<template>
  <div class="profile">
    <img src="../../assets/images/home/jianjie.png" alt="">
    <div class="container">
      <h3>一线快递特色：</h3>
      <p>随时下单，即刻上门，无论何时何地，无需预约，一线快递24小时静候您的召唤。</p>
      <p>安全便捷，专人直送，快递员即取即送，配送无中转环节，直达目的地，全程实时监控，先行赔付机制。同城1小时，极速送达；5公里平均23分钟送达，10公里平均33分钟送达，15公里平均39分钟送达。</p>
      <h3> 一线快递服务：</h3>
      <p>一线快递APP下单后，同城1分钟响应，10分钟上门，1小时速递全城：</p>
      <p>同城美食配送（生鲜、水果、蛋糕、零食、外卖等）</p>
      <p>同城急件配送（合同、文件、发票、身份证、护照、钱包、钥匙等）</p>
      <p>同城购物配送（鲜花、药品、烟酒、宠物、书籍、服装、数码产品等）</p>
      <p>医疗服务帮您预约排队、帮您挂号、陪护等。</p>
      <p>帮您预定火车票，飞机票，演唱会票，球赛票等</p>
      <h3>体验一线快递：</h3>
      <p>新用户通过下载APP,微信公众号（一线快递），官网（www.yixian-express.com）进行下单体验，即可获专享38元优惠券。</p>
      <h3>一线快递公司：</h3>
      <p>公司成立于2016.2.4，发展至今，已经有上万个用户成为一线快递的忠实粉丝，享受着一线快递高效、快捷、安全的服务，一线快递是国内响应时间最短、取送速度最快、服务体验优先、用户规模大的限时速递服务公司之一。 </p>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less" type="text/less">
  .profile{
    margin-bottom: 63px;
    .container{
      margin-top:30px;
      h3{
        font-size: 16px;
        color:#000;
        font-weight: bold;
        line-height: 30px;
      }
      p{
        line-height: 30px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Home/Profile.vue